import { forwardRef, useImperativeHandle, useRef, useState } from 'react';
import { AgencyForm } from '../forms/AgencyForm';
import { EditAgencyFormDrawerProps } from '../../interfaces/types';
import { Drawer } from '@navi/web-ui/lib/primitives';
import { DrawerFooter } from '../DrawerFooter';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '@cp/src/store';
import { setIsModalOpen } from '@cp/src/reducers/AgencyDetailsSlice';

const EditFormDrawer = forwardRef((props: EditAgencyFormDrawerProps, ref) => {
  const { onClose, isDrawerOpen } = props;

  const isTerminateAgencyOptionSelected = useSelector(
    (state: RootState) => state?.agencyDashboard?.isTerminateAgencyOptionSelected
  );
  const agencyFormRef = useRef<any>(null);
  const [isOutsideClick, setIsOutsideClicked] = useState(false);
  const [isSubmitButtonDisabled, setIsSubmitButtonDisabled] = useState(false);
  const [isDirtyField, setIsDirtyField] = useState(false);
  const dispatch = useDispatch();

  const handleSubmitClick = () => {
    if (isTerminateAgencyOptionSelected) {
      dispatch(setIsModalOpen(true));
      return;
    }

    if (agencyFormRef?.current) {
      agencyFormRef.current?.submitForm();
    }
  };
  const handleTerminateAgencySubmitClick = () => {
    if (agencyFormRef?.current) {
      agencyFormRef.current?.submitForm();
    }
  };
  useImperativeHandle(ref, () => ({
    handleSubmitFormClick: handleTerminateAgencySubmitClick
  }));

  const toggleOutsideClick = () => {
    if (isDirtyField) {
      setIsOutsideClicked(true);
    } else {
      setIsOutsideClicked(false);
      onClose();
    }
  };

  const handleExitYesClick = () => {
    setIsOutsideClicked(false);
    onClose();
  };

  const handleExitNoClick = () => {
    setIsOutsideClicked(false);
  };

  return (
    <Drawer
      open={isDrawerOpen}
      onClose={isDirtyField ? toggleOutsideClick : onClose}
      headerText={'Edit Agency'}
      showHeaderDivider={true}
      usePadding={false}
      className="!w-[415px]"
      contentClasses="overflow-auto"
      onOutSideClick={toggleOutsideClick}
      disableOutsideClick={isDirtyField ? true : false}
      footerContainerClasses={isOutsideClick ? '!bg-[var(--navi-color-red-bg)]' : ''}
      footer={
        <DrawerFooter
          handleSubmitClick={handleSubmitClick}
          isSubmitButtonDisabled={isSubmitButtonDisabled}
          handleExitYesClick={handleExitYesClick}
          handleExitNoClick={handleExitNoClick}
          onClose={onClose}
          toggleOutsideClick={toggleOutsideClick}
          isDirtyField={isDirtyField}
          isOutsideClick={isOutsideClick}
          isEditAgencyPage={true}
        />
      }
    >
      <section>
        <AgencyForm
          ref={agencyFormRef}
          onClose={onClose}
          isDrawerOpen={isDrawerOpen}
          setIsSubmitButtonDisabled={setIsSubmitButtonDisabled}
          isEditAgencyPage={true}
          setIsDirtyField={setIsDirtyField}
        />
      </section>
    </Drawer>
  );
});

export default EditFormDrawer;
